// src/attractions/attractionApi.ts
import { apiClient } from "@maat/api-base";
var attractionApi = {
  // Public, guest-readable: visible POIs for the property listing drawer.
  // Population & moderation are admin-only — see adminAreaApi.
  getAttractions: async (params) => {
    return apiClient.get("/main/api/attractions", { params });
  }
};

export {
  attractionApi
};
